import { ProjectType } from '@cartwhl/common/types';
import { getStudioUrl } from '@cartwhl/common/utils/getStudioUrl';
import Dropdown from '@cartwhl/ui/atoms/Dropdown';
import ChevronDownIcon from '@cartwhl/ui/icons/ChevronDownIcon';
import DiamondIcon from '@cartwhl/ui/icons/DiamondIcon';
import PlusIcon from '@cartwhl/ui/icons/PlusIcon';
import Button from '@cartwhl/ui/input/Button';

import { projectStore, sceneSettingsStore } from 'stores';

export default function NewProjectDropdown({
  className,
  hasPoseModeAccess,
}: {
  className?: string;
  hasPoseModeAccess: boolean;
}) {
  return (
    <Dropdown
      width={150}
      align="start"
      trigger={
        <Button
          variant="secondary"
          size="sm"
          icon={<PlusIcon />}
          className={`text-gray-90 pr-1.5 ${className}`}
        >
          <div className="flex items-center gap-4">
            Create new <ChevronDownIcon className="h-4 w-4" />
          </div>
        </Button>
      }
    >
      <Dropdown.Item
        icon={<DiamondIcon className="text-green-50" />}
        onClick={async () => {
          sceneSettingsStore.reset();
          const projectData = await projectStore.createNewProject(
            ProjectType.MOTION,
          );
          if (projectData) {
            window.location.href = `${getStudioUrl()}/motion/${projectData.projectID}`;
          }
        }}
      >
        Motion
      </Dropdown.Item>
      {hasPoseModeAccess && (
        <Dropdown.Item
          icon={<DiamondIcon className="text-violet" />}
          onClick={async () => {
            sceneSettingsStore.reset();
            const projectData = await projectStore.createNewProject(
              ProjectType.POSE,
            );
            if (projectData) {
              window.location.href = `${getStudioUrl()}/pose/${projectData.projectID}`;
            }
          }}
        >
          Pose
        </Dropdown.Item>
      )}
    </Dropdown>
  );
}
